import { APP_LINKS, URL_PARAMS } from '@utils/variables';
import { atom } from 'jotai';
import { NextRouter } from 'next/router';

// This atom store the NextRouter so it can be used to derived atoms
export const appRouterAtom = atom<NextRouter>({} as NextRouter);

// This atom store the NextRouter.query
export const subpageQueryParamAtom = atom<string | undefined>((get) => {
	const { query } = get(appRouterAtom);
	if (!query) return undefined;

	const value = query[URL_PARAMS.subpage];
	return Array.isArray(value) ? value[0] : value;
});

// This atom store the NextRouter.pathname
export const pathnameQueryAtom = atom<string | undefined>((get) => {
	const { pathname } = get(appRouterAtom);
	return pathname;
});

// This atom stores the NextRouter.query.slug
export const slugQueryAtom = atom<string | undefined>((get) => {
	const { query } = get(appRouterAtom);

	if (!query) return undefined;

	const { slug } = query;

	return Array.isArray(slug) ? slug[0] : slug;
});

export const isSingleQuestPageAtom = atom<boolean>((get) => {
	return get(appRouterAtom).route === APP_LINKS.singleQuest.href;
});
